import styled, { css } from 'styled-components';
import Separator from '@westwing/ui-kit/Separator';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { StyledFormActions } from '../loginAndRegistration.style';

export const StyledWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: flex-start;
`;

export const StyledSeparator = styled(Separator)`
    flex: 1 0 100%;
    ${forDesktop`
        display: none;
    `}
`;
export const StyledContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    flex: 1 1 20rem;
    ${forDesktop`
        margin: 6px;
        padding: 40px;
    `}
`;

export const PartialLoginCard = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    margin: 20px auto 40px auto;
    ${forDesktop`
         max-width: 674px;
    `}
`;

export const animate = css`
    &[aria-expanded='true'] {
        transition: 0.4s ease-out;
        transition-delay: 0.1s;
        max-height: 500px;
    }
    &[aria-expanded='false'] {
        transition: 0.5s all ease-out;
        max-height: 0;
    }
    &[aria-expanded='true'] + div {
        transition: 0.2s all ease-out;
        max-height: 0;
        overflow: hidden;
        border: none;
        opacity: 0;
    }
    &[aria-expanded='false'] + div {
        transition: 0.2s ease-out;
        transition-delay: 0.3s;
        max-height: 200px;
        opacity: 1;
    }
`;

export const StyledFormWrapper = styled.div`
    overflow: hidden;
    ${animate}
`;

export const StyledToggleActions = styled(StyledFormActions)`
    margin: 0px auto;
`;
